import { Flex, Typography } from "antd"

import { CURRENT_MONTH_SLOT } from "../monitoringCopy"
import { countReachedLimits, evaluateMonthLimits, hasResolvableLimits } from "../programLimits"

import "./CurrentMonthSlot.less"

const { Text } = Typography

const CurrentMonthSlot = ({ program, currentMonth, thresholds, region }) => {
  if (!currentMonth?.month_name) return null

  const canResolveLimits = hasResolvableLimits({ program, region, thresholds })
  const limits = canResolveLimits
    ? evaluateMonthLimits({ program, month: currentMonth, thresholds, region })
    : []

  return (
    <div className="current-month-slot">
      <Text type="secondary" className="current-month-slot__label">
        {CURRENT_MONTH_SLOT.label(currentMonth.month_name)}
      </Text>
      <Flex align="center" gap={8} className="current-month-slot__state">
        <span className="current-month-slot__dot" />
        <Text className="status-text pending">{CURRENT_MONTH_SLOT.state}</Text>
        {/* Region not recognised → limits cannot be resolved, so the counter is dropped while the
            state line and the note remain (§5 Edge cases). */}
        {canResolveLimits && (
          <Text type="secondary" className="current-month-slot__counter">
            {CURRENT_MONTH_SLOT.counter(countReachedLimits(limits), limits.length)}
          </Text>
        )}
      </Flex>
      <Text type="secondary" className="current-month-slot__note">
        {CURRENT_MONTH_SLOT.note(currentMonth.month)}
      </Text>
    </div>
  )
}

export default CurrentMonthSlot
